import { render, staticRenderFns } from "./AdminDropped2024List.vue?vue&type=template&id=0182205e&scoped=true"
import script from "./AdminDropped2024List.vue?vue&type=script&lang=js"
export * from "./AdminDropped2024List.vue?vue&type=script&lang=js"
import style0 from "./AdminDropped2024List.vue?vue&type=style&index=0&id=0182205e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0182205e",
  null
  
)

export default component.exports